const dashboardControllers = angular.module('dashboard.module', ['ui.router']);

dashboardControllers.controller('dashboardController', function(
  $scope,
  $uibModal,
  $rootScope,
  gridletService,
  userViewService,
  eventService,
  CommonService
) {
  $scope.view = 'dashboard';
  userViewService.setView('dashboard');
  $scope.customizable = angular.copy(gridletService.getCustomizable());

  CommonService.setSelectedTrain(null);
  
  let unbindDash = $rootScope.$on('toggle-customization', function(
    event,
    args
  ) {
    $scope.customizable = args.customize;
  });
  $scope.$on('$destroy', unbindDash);

  eventService.on('reset-widgets', function() {
    $scope.$broadcast('update-gridlet-list');
  });

  eventService.on('restore-default-widgets', function() {
    $scope.$broadcast('restore-default-widgets');
  });

  let unbindAddGridlet = $rootScope.$on('add-gridlet', function(event, args) {
    if (args.currentTab !== 'dashboard') return;
    gridletService.addNewGridlet($scope.view, args.gridletId);
    $scope.$broadcast('update-gridlet-list');
  });
  $scope.$on('$destroy', unbindAddGridlet);

  $scope.$on('$destroy', function() {
    if ($scope.customizable) {
      $scope.customizable = false;
      $rootScope.$emit('disable-customization');
    }
  });
});
